import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { OrgJed } from './orgjed';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators} from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-orgjed-update',
  templateUrl: './orgjed-update.component.html'
})
export class OrgJedUpdateComponent extends BaseUpdateComponent<OrgJed> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
      super.ngOnInit();
      this.addValidatorToFc("Naziv", Validators.required, 'required', 'ORGJED.NAZIV.VALIDATION.REQUIRED');
  }

}
